import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./SearchInput.scss";

export default class SearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || ""
    };

    this.inputRef = React.createRef(null);
  }

  onChange = e => {
    this.setState({ value: e.target.value });
    this.props.onChange && this.props.onChange(e);
  };

  onClick = () => {
    //this.props.onDone(this.state.value);
    this.setState({ value: "" });
    const fakeEvent = {
      target: {
        value: ""
      }
    };
    this.props.onChange && this.props.onChange(fakeEvent);
  };

  onKeyDown = e => {
    /*if (e.keyCode == 13) {
            this.onClick();
        }*/
  };

  static getDerivedStateFromProps(props) {
    return { value: props.value };
  }

  componentDidMount() {
    this.inputRef.current.focus();
  }

  render() {
    const { placeholder, disabled, theme } = this.props;

    return (
      <div
        className={classnames("search-input", {
          "search-input__disabled": disabled,
          "search-input__dark": theme == "dark",
          "search-input__active": (this.state.value || "").length != 0
        })}
      >
        <input
          className="search-input__input"
          type="text"
          placeholder={placeholder}
          value={this.state.value}
          onChange={this.onChange}
          onKeyDown={this.onKeyDown}
          ref={this.inputRef}
        />
        <i onClick={this.onClick} />
      </div>
    );
  }
}

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  onDone: PropTypes.func,
  theme: PropTypes.string,
  onChange: PropTypes.func
};

SearchInput.defaultPrps = {
  placeholder: ""
};
